import React from 'react';

import classnames from 'clsx';

import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

import { formatDateLong } from '~/services/TimeService';

// getLabel returns a label to be shown in <TravelDates />
function getLabel(
  startDate: Date | string | number | undefined,
  endDate: Date | string | number | undefined,
  disabled?: boolean,
) {
  if (disabled) {
    return 'Book Later';
  }

  if (!startDate || !endDate) {
    return 'Select dates';
  }

  return `${formatDateLong(startDate)} - ${formatDateLong(endDate)}`;
}

interface Props {
  startDate?: Date | string | number;
  endDate?: Date | string | number;
  onStartBookingDates: React.MouseEventHandler<HTMLElement>;
  disabled?: boolean;
}

function TravelDates({ startDate, endDate, onStartBookingDates, disabled }: Props) {
  const label = getLabel(startDate, endDate, disabled);

  return (
    <div className={classnames('travel-dates booking-input', { disabled })} onClick={onStartBookingDates} role="button">
      <span
        className={classnames('date-label data-hj-whitelist', {
          empty: !startDate || !endDate,
        })}
      >
        {label}
      </span>
      <button onClick={onStartBookingDates} className="datepicker-trigger" disabled={disabled}>
        <CalendarTodayIcon fontSize="small" />
      </button>
    </div>
  );
}

export default TravelDates;
